var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm rounded-left-0",staticStyle:{"width":"100%","height":"80vh"},attrs:{"id":"map_canvas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }